import { ShieldAlert } from 'lucide-react';

interface AccessDeniedProps {
  message?: string;
}

/**
 * Inline "your role can't see this" notice, for a page or tab the signed-in
 * user's role doesn't allow. Prefer this over rendering the page and letting
 * its requests 403 into a spinner that never resolves.
 */
export default function AccessDenied({
  message = 'Your role does not allow access to this page.',
}: AccessDeniedProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-3 rounded-lg border p-12 text-center"
    >
      <ShieldAlert className="h-8 w-8 text-muted-foreground" />
      <p className="text-sm font-medium">{message}</p>
      <p className="text-sm text-muted-foreground">
        Ask an administrator of your organization if you need access.
      </p>
    </div>
  );
}
